import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Zap } from 'lucide-react';
import { Button } from './Button';
export const OfferSection: React.FC = () => {
  return <section className="py-24 px-4 md:px-8 bg-brand-primary text-white relative overflow-hidden" data-id="element-98">
      {/* Decorative background elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-brand-medium rounded-full mix-blend-screen filter blur-3xl opacity-50 translate-x-1/2 -translate-y-1/2" data-id="element-99"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-brand-soft rounded-full mix-blend-screen filter blur-3xl opacity-30 -translate-x-1/2 translate-y-1/2" data-id="element-100"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-101">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-102">
          <h2 className="text-3xl md:text-5xl font-bold font-serif mb-4" data-id="element-103">
            Accedé ahora a COCINA VIANDERA
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-white text-brand-text-dark rounded-3xl p-8 md:p-12 shadow-2xl max-w-2xl mx-auto" data-id="element-104">
          <div className="space-y-4 mb-8" data-id="element-105">
            <div className="flex justify-between items-center border-b border-gray-100 pb-4" data-id="element-106">
              <span className="font-medium" data-id="element-107">
                Ebook principal COCINA VIANDERA
              </span>
              <span className="text-gray-500" data-id="element-108">Valor $30.000</span>
            </div>
            <div className="flex justify-between items-center border-b border-gray-100 pb-4" data-id="element-109">
              <span className="font-medium" data-id="element-110">15 Bonos incluidos</span>
              <span className="text-gray-500" data-id="element-111">Valor $133.500</span>
            </div>
            <div className="flex justify-between items-center pt-2" data-id="element-112">
              <span className="font-bold text-lg" data-id="element-113">Valor Total:</span>
              <span className="text-gray-400 line-through text-lg" data-id="element-114">
                $163.500
              </span>
            </div>
          </div>

          <div className="text-center mb-8" data-id="element-115">
            <div className="inline-block bg-brand-cream text-brand-primary font-bold px-4 py-1 rounded-full text-sm mb-4" data-id="element-116">
              50% OFF — Oferta de lanzamiento
            </div>
            <div className="text-6xl md:text-7xl font-bold text-brand-primary mb-2 flex justify-center items-start" data-id="element-117">
              <span className="text-3xl mt-2 mr-1" data-id="element-118">$</span>
              15.990
            </div>
          </div>

          <div className="flex flex-col items-center space-y-4" data-id="element-119">
            <Button fullWidth className="py-5 text-xl shadow-brand-cta/30" data-id="element-120">
              QUIERO EMPEZAR AHORA →
            </Button>
            <p className="text-sm text-brand-text-medium font-medium text-center" data-id="element-121">
              Acceso inmediato + descarga del ebook y los 15 bonos
            </p>
          </div>

          <div className="flex justify-center space-x-6 mt-8 pt-6 border-t border-gray-100" data-id="element-122">
            <div className="flex items-center text-sm text-brand-text-medium" data-id="element-123">
              <ShieldCheck className="w-5 h-5 text-brand-soft mr-2" data-id="element-124" />
              Garantía 2 días
            </div>
            <div className="flex items-center text-sm text-brand-text-medium" data-id="element-125">
              <Zap className="w-5 h-5 text-brand-soft mr-2" data-id="element-126" />
              Acceso Inmediato
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
};